import React, { Fragment } from "react";
import PropTypes, { InferProps } from "prop-types";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import {
  Timeline,
  TimelineItem,
  TimelineSeparator,
  TimelineConnector,
  TimelineContent,
  TimelineDot,
} from "@mui/lab";

function Construction() {
  const steps = [
    "Initiate Construction",
    "Create/Modify Construction",
    "Review/Approve Construction",
    "Client sign-off Construction",
  ];
  const divStyle = {
    color: "blue",
    width: "50%",
    marginTop: 20,
  };
  return (
    <Fragment>
      <Box display="flex" justifyContent="flex-start" flexDirection="column">
        <div style={divStyle}> Construction</div>
        <Timeline position="right">
          <TimelineItem>
            <TimelineSeparator>
              <TimelineDot />
              <TimelineConnector />
            </TimelineSeparator>
            <TimelineContent>
              <Box
                justifyContent="space-between"
                flexDirection="row"
                display="flex"
              >
                <div> {steps[0]}</div>
                <Button variant="contained">Update</Button>
              </Box>
            </TimelineContent>
          </TimelineItem>

          <TimelineItem>
            <TimelineSeparator>
              <TimelineDot />
              <TimelineConnector />
            </TimelineSeparator>
            <TimelineContent>
              <Box
                justifyContent="space-between"
                flexDirection="row"
                display="flex"
              >
                <div> {steps[1]}</div>
              </Box>
            </TimelineContent>
          </TimelineItem>

          <TimelineItem>
            <TimelineSeparator>
              <TimelineDot />
              <TimelineConnector />
            </TimelineSeparator>
            <TimelineContent>
              <Box
                justifyContent="space-between"
                flexDirection="row"
                display="flex"
              >
                <div> {steps[2]}</div>
              </Box>
            </TimelineContent>
          </TimelineItem>

          <TimelineItem>
            <TimelineSeparator>
              <TimelineDot />
            </TimelineSeparator>
            <TimelineContent>
              <Box
                justifyContent="space-between"
                flexDirection="row"
                display="flex"
              >
                <div> {steps[3]}</div>
              </Box>
            </TimelineContent>
          </TimelineItem>
        </Timeline>
      </Box>
    </Fragment>
  );
}

Construction.propTypes = {
  phase: PropTypes.string,
};
export default Construction;
